import * as typings from '../../typings'
import * as actionTypes from './actionTypes'

export const countryAndLanguageUpdated = (
  country: typings.Countries,
  language: typings.Languages,
) => ({
  type: actionTypes.COUNTRY_AND_LANGUAGE_UPDATED,
  payload: {
    country,
    language,
  },
})

export const countryUpdated = (country: typings.Countries) => ({
  type: actionTypes.COUNTRY_UPDATED,
  payload: {
    country,
  },
})

export const languageUpdated = (language: string) => ({
  type: actionTypes.LANGUAGE_UPDATED,
  payload: {
    language,
  },
})

export const geoRequested = (limit?: number) => ({
  type: actionTypes.GEO_REQUESTED,
  payload: {
    limit,
  },
})

export const geoUpdated = (coords: GeoCoordinateType, radius: number) => ({
  type: actionTypes.GEO_UPDATED,
  payload: { ...coords, radius },
})

export const geoCleared = () => ({
  type: actionTypes.GEO_CLEARED,
})
